export default __webpack_public_path__ + "static/media/unpic.296dca5e.jpg";